import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Fragment } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { connect } from 'react-redux';
import Form, { FormMessage } from '/@/components/form';
import Popup from '/@/components/popup';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { getSessionCountries, getSessionCountry } from '/@/store/session/selectors';
import { validateEmail } from '/@/utils';
import 'react-phone-input-2/lib/style.css';
import { Box, FormControl, FormHelperText, Stack, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { autobind } from 'core-decorators';
import { enqueueSnackbar } from 'notistack';
import { openPrivacyPolicy } from '/@/components/new-login/login';
import colors from '/@/components/theme-provider/colors';
import { MuiSelect } from '/@/mui/select';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import AREA_CODES from '/@/utils/area-codes';
import { messageForUser } from '/@/utils/errors';
import { validatePhoneNumber } from '/@/utils/phone-numbers';
import Input from '/@/v3/components/forms/input';
import stylesInput from '/@/v3/components/forms/input/styles.module.css';
import Label from '/@/v3/components/forms/label';
import Toggle from '/@/v3/components/forms/toggle';
import Title from '/@/v3/components/title';
import ConfirmDeleteAccount from './confirm-delete-account';
// v3 components
import DeleteAccount from './delete-account';
import FinishDeleteAccount from './finish-delete-account';
import styles from './styles.module.css';
import deleteAccount from './useDeleteAccount';

@connect((state) => ({
    country: getSessionCountry(state),
    countries: getSessionCountries(state),
}))
@autobind
export default class Userform extends Form {
    static propTypes = {
        user: PropTypes.object,
        fields: PropTypes.object,
        nextUrl: PropTypes.string,
        onSubmit: PropTypes.func,
        validation: PropTypes.object,
        enforceReceiveNotifications: PropTypes.bool,
        enforceReceiveWhatsappNotifications: PropTypes.bool,
        isPasswordCompleted: PropTypes.bool,
        login: PropTypes.bool,
        passwordView: PropTypes.bool,
        notifications: PropTypes.bool,
        loginView: PropTypes.bool,
        showButtonDeleteAccount: PropTypes.bool,
        disabledFields: PropTypes.array,
        returnUrl: PropTypes.string,
        onSubmitAfterWelcome: PropTypes.func,
    };

    static defaultProps = {
        fields: {},
        valildation: {},
        shouldValidate: [],
        login: false,
        disabledFields: [],
    };

    static contextTypes = {
        theme: PropTypes.string,
        history: PropTypes.object,
    };

    state = {
        apiError: '',
        touched: [],
        showWelcome: false,
        showPopupDeleteAccount: false,
        showPopupConfirmDeleteAccount: false,
        showPopupFinishDeleteAccount: false,
    };

    firstFields = {
        firstName: {
            initial: (this.props.user && this.props.user.first_name) || '',
        },
        lastName: {
            initial: (this.props.user && this.props.user.last_name) || '',
        },
        phone: {
            initial: (this.props.user && this.props.user.phone) || '',
        },
        type: {
            initial: (this.props.user && this.props.user.type) || undefined,
        },
        subtype: {
            initial: (this.props.user && this.props.user.subtype) || undefined,
            required: false,
        },
    };

    secondFields = {
        email: {
            initial: (this.props.user && this.props.user.email) || '',
        },
        receiveNotifications: {
            initial:
                this.props.enforceReceiveNotifications ||
                Boolean(this.props.user && this.props.user.receive_notifications),
            required: false,
        },
        receiveWhatsappNotifications: {
            initial:
                this.props.enforceReceiveWhatsappNotifications ||
                Boolean(this.props.user && this.props.user.receive_whatsapp_notifications),
            required: false,
        },
        ...this.props.fields,
    };

    fields = {
        firstName: {
            initial: (this.props.user && this.props.user.first_name) || '',
        },
        lastName: {
            initial: (this.props.user && this.props.user.last_name) || '',
        },
        email: {
            initial: (this.props.user && this.props.user.email) || '',
        },
        phone: {
            initial: (this.props.user && this.props.user.phone) || '',
        },
        type: {
            initial: (this.props.user && this.props.user.type) || undefined,
        },
        subtype: {
            initial: (this.props.user && this.props.user.subtype) || undefined,
            required: false,
        },
        receiveNotifications: {
            initial:
                this.props.enforceReceiveNotifications ||
                Boolean(this.props.user && this.props.user.receive_notifications),
            required: false,
        },
        receiveWhatsappNotifications: {
            initial:
                this.props.enforceReceiveWhatsappNotifications ||
                Boolean(this.props.user && this.props.user.receive_whatsapp_notifications),
            required: false,
        },
        ...this.props.fields,
    };

    shouldValidate = ['type', 'subtype'].reduce((result, field) => {
        if (!this.props.user) return result;
        if (this.props.user[field]) result.push(field);
        return result;
    }, []);

    validation = {
        email: (values) => {
            const emailValidation = validateEmail(values.email);
            if (emailValidation !== true) return emailValidation;
            if (this.isInternal(values) && !this.isInternalEmail(values)) {
                return _('Por favor usá tu email @bayer.com.');
            }
            return true;
        },
        type: (values) => {
            return true;
        },
        subtype: (values) => {
            if (this.isInternal(values) && !values.subtype) return _('Por favor seleccioná un rol de usuario.');
            return true;
        },
        ...this.props.validation,
    };

    isInternal(values) {
        return values.type === 'bayer';
    }

    isInternalEmail(values) {
        return settings.internalProfileEmailDomains.some((domain) => values.email.endsWith(domain));
    }

    handleAfterChange(key) {
        if (key !== 'type') return;
        if (!this.isInternal(this.state.values)) this.clear('subtype', '');
    }

    renderTerms() {
        return (
            <div className={styles.terms}>
                {_('Acepto los')}
                <div onClick={this.props.onClickTerms} className={styles.termsLink}>
                    {_('términos y condiciones')}
                </div>
            </div>
        );
    }

    renderPrivacyPolicy() {
        return (
            <div className={styles.privacyPolicy}>
                {_('Acepto la')}
                <div className={styles.termsLink} onClick={openPrivacyPolicy}>
                    {_('política de privacidad')}
                </div>
            </div>
        );
    }

    validatePassword() {
        if (this.state.values.password.length > 4) {
            return true;
        }
        return;
    }

    async changeToWelcomeView() {
        this.setState({ loading: true, apiError: '' });
        try {
            await this.props.onSubmit(this.state.values);
            this.setState({ loading: false });
            if (this.props.loginView) {
                this.props.changeToWelcomeView();
            }
            if (!this.props.loginView) {
                this.handleSubmit();
            }
            enqueueSnackbar({ message: _('Guardado exitosamente'), variant: 'success' });
        } catch (error) {
            this.setState({ loading: false, apiError: messageForUser(error, _('Ha ocurrido un error...')) });
        }
    }

    handleSubmit() {
        if (this.props.showWelcome) this.props.onSubmitAfterWelcome(this.state.values);
        if (this.props.nextUrl) this.context.history(decodeURIComponent(this.props.nextUrl), { replace: true });
        else this.context.history.goBack();
    }

    validateFields(fields) {
        if (this.state.loading) return false;
        if (!Object.keys(fields).every((field) => this.hasError(field) === false)) return false;
        return true;
    }

    togglePopupDeleteAccount() {
        if (!this.state.showPopupDeleteAccount) mpTrackEvent('Delete account began', undefined);
        this.setState((prevState) => ({ showPopupDeleteAccount: !prevState.showPopupDeleteAccount }));
    }

    async togglePopupConfirmDeleteAccount() {
        if (!this.props.user) return;
        if (this.props.user.has_usable_password) {
            this.setState((prevState) => ({
                showPopupDeleteAccount: !prevState.showPopupDeleteAccount,
                showPopupConfirmDeleteAccount: !prevState.showPopupConfirmDeleteAccount,
            }));
        } else {
            const booleanDeleteAccount = await deleteAccount({
                user: this.props.user,
                password: undefined,
                setErrorPassword: () => {},
            });
            this.setState(() => ({
                showPopupConfirmDeleteAccount: false,
                showPopupDeleteAccount: !booleanDeleteAccount,
                showPopupFinishDeleteAccount: booleanDeleteAccount,
            }));
        }
    }

    handleCancel() {
        if (this.props.returnUrl) return this.context.history(this.props.returnUrl);
        this.context.history.goBack();
    }

    showError(key) {
        return (
            this.getFieldProps(key).error ||
            (this.required.includes(key) && !this.state.values[key] && this.state.touched.includes(key))
        );
    }

    render() {
        return (
            <div className={`${styles.root} mp-mask`}>
                {!this.props.password && !this.props.notifications && (
                    <div>
                        <TextField
                            helperText={_('Requerido*')}
                            FormHelperTextProps={{ sx: { fontSize: 9, color: 'black' } }}
                            value={this.getFieldProps('firstName').value}
                            onChange={(e) => {
                                this.getFieldProps('firstName').onChange(e.target.value);
                            }}
                            label={_('Nombre')}
                            onBlur={() => {
                                this.setState((prevState) => ({
                                    touched: [...prevState.touched, 'firstName'],
                                }));
                            }}
                            fullWidth
                            size='small'
                            error={this.showError('firstName')}
                        />

                        <div className={styles.lastNameInput}>
                            <TextField
                                helperText={_('Requerido*')}
                                FormHelperTextProps={{ sx: { fontSize: 9, color: 'black' } }}
                                value={this.getFieldProps('lastName').value}
                                onChange={(e) => {
                                    this.getFieldProps('lastName').onChange(e.target.value);
                                }}
                                label={_('Apellido')}
                                fullWidth
                                size='small'
                                onBlur={() => {
                                    this.setState((prevState) => ({
                                        touched: [...prevState.touched, 'lastName'],
                                    }));
                                }}
                                error={this.showError('lastName')}
                            />
                        </div>

                        {!this.props.login && (
                            <TextField
                                helperText={_('Requerido*')}
                                FormHelperTextProps={{ sx: { fontSize: 9, color: 'black' } }}
                                value={this.getFieldProps('email').value}
                                onChange={(e) => {
                                    this.getFieldProps('email').onChange(e.target.value);
                                }}
                                error={this.getFieldProps('email').error}
                                label={_('E-mail')}
                                fullWidth
                                size='small'
                                disabled={this.props.disabledFields.some((el) => el === 'email')}
                            />
                        )}
                        <FormControl fullWidth>
                            <PhoneInput
                                onChange={this.handleChange('phone')}
                                disabled={this.state.loading}
                                onKeyDown={this.handleKeyDown}
                                value={this.state.values['phone']}
                                buttonStyle={{
                                    border: 'none',
                                }}
                                specialLabel=''
                                country={this.props.country.code.toLowerCase()}
                                preferredCountries={this.props.countries.map((c) => c.code.toLowerCase())}
                                containerStyle={{
                                    fontFamily: 'inherit',
                                    borderRadius: '4px',
                                }}
                                inputClass={classNames(styles.phoneInput, stylesInput[`color-${settings.app.theme}`])}
                                containerClass={`${stylesInput[`color-${settings.app.theme}`]}`}
                                inputStyle={{
                                    fontSize: '14px',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    borderColor: 'inherit',
                                }}
                                enableAreaCodeStretch
                                enableAreaCodes
                                areaCodes={AREA_CODES}
                                masks={{ mx: '... .... ....' }}
                            />
                            <FormHelperText
                                sx={{
                                    fontSize: 9,
                                    color:
                                        this.props.loginView &&
                                        !validatePhoneNumber(this.state.values['phone']) &&
                                        this.state.values['phone']
                                            ? 'red'
                                            : 'black',
                                }}
                            >
                                {_('Requerido*')}{' '}
                                {this.props.loginView &&
                                !validatePhoneNumber(this.state.values['phone']) &&
                                this.state.values['phone']
                                    ? _('El formato del número de teléfono es incorrecto.')
                                    : ''}
                            </FormHelperText>
                        </FormControl>
                        <Box sx={{ my: 3 }}>
                            <MuiSelect
                                formHelperText={_('Requerido*')}
                                formControlProps={{ fullWidth: true, size: 'small' }}
                                inputLabelProps={{ sx: { fontWeight: 300 } }}
                                inputLabel={_('Seleccioná un tipo de usuario')}
                                formHelperTextProps={{ sx: { fontSize: 9, color: 'black' } }}
                                width='100%'
                                options={settings.choices.userTypes}
                                value={this.getFieldProps('type').value}
                                onChange={(e) => {
                                    this.getFieldProps('type').onChange(e.target.value);
                                }}
                                disabled={this.props.user.validated_type}
                                error={this.showError('type')}
                                sx={{ color: colors.input.fontColor, textAlign: 'start' }}
                            />
                        </Box>

                        {this.isInternal(this.state.values) && (
                            <MuiSelect
                                formControlProps={{ fullWidth: true, size: 'small', sx: { mb: 2 } }}
                                inputLabelProps={{ sx: { fontWeight: 300 } }}
                                inputLabel={_('¿Qué clase de usuario sos?')}
                                formHelperText={_('Requerido*')}
                                width='100%'
                                options={settings.choices.userSubtypes}
                                value={this.getFieldProps('subtype').value}
                                error={this.showError('subtype')}
                                onChange={(e) => {
                                    this.getFieldProps('subtype').onChange(e.target.value);
                                }}
                                disabled={this.props.user.validated_type}
                                formHelperTextProps={{ sx: { fontSize: 9, color: 'black' } }}
                                sx={{ color: colors.input.fontColor, textAlign: 'start' }}
                            />
                        )}
                        {this.props.children && this.props.children({ getFieldProps: this.getFieldProps })}
                        {!this.props.login && (
                            <Label
                                text={_('Acepto recibir emails y mensajes de la app')}
                                appearance='row'
                                reverse
                                size='sm'
                            >
                                <Toggle
                                    type='radio'
                                    theme={settings.app.theme}
                                    {...this.getFieldProps('receiveNotifications')}
                                />
                            </Label>
                        )}
                        {!this.props.login && (
                            <Label
                                text={_('Acepto recibir mensajes de whatsapp de la app')}
                                appearance='row'
                                reverse
                                size='sm'
                            >
                                <Toggle
                                    type='radio'
                                    theme={settings.app.theme}
                                    {...this.getFieldProps('receiveWhatsappNotifications')}
                                />
                            </Label>
                        )}
                        {!this.props.login && (
                            <Stack direction='column' spacing={1} sx={{ mt: 2 }}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    disabled={this.state.loading || !this.validate()}
                                    onClick={this.changeToWelcomeView}
                                >
                                    {this.state.loading ? _('Guardando...') : _('Guardar')}
                                </Button>
                                {this.state.apiError && !this.props.loginView && (
                                    <FormMessage style='error'>{this.state.apiError}</FormMessage>
                                )}
                                <Button variant='outlined' onClick={this.handleCancel}>
                                    {_('Cancelar')}
                                </Button>
                                {this.props.showButtonDeleteAccount && (
                                    <Button variant='outlined' color='error' onClick={this.togglePopupDeleteAccount}>
                                        {_('Eliminar Cuenta')}
                                    </Button>
                                )}
                            </Stack>
                        )}
                    </div>
                )}
                {this.props.notifications && (
                    <Label
                        text={_('Acepto recibir emails y mensajes de la app')}
                        appearance='row'
                        reverse
                        size='sm'
                        color='gray-light'
                    >
                        <Toggle
                            type='radio'
                            theme={settings.app.theme}
                            {...this.getFieldProps('receiveNotifications')}
                        />
                    </Label>
                )}
                {this.props.notifications && (
                    <Label
                        text={_('Acepto recibir mensajes de whatsapp de la app')}
                        appearance='row'
                        reverse
                        size='sm'
                        color='gray-light'
                    >
                        <Toggle
                            type='radio'
                            theme={settings.app.theme}
                            {...this.getFieldProps('receiveWhatsappNotifications')}
                        />
                    </Label>
                )}
                {
                    <Fragment>
                        {this.props.password && (
                            <div>
                                {!this.props.social && (
                                    <div className={styles.inputContainer}>
                                        <Input
                                            color={settings.app.theme}
                                            type='email'
                                            size='md'
                                            appearance='outline'
                                            placeholder={_('Escribí tu email')}
                                            {...this.getFieldProps('email')}
                                        />
                                        <div>
                                            <Input
                                                color={settings.app.theme}
                                                type='password'
                                                size='md'
                                                appearance='outline'
                                                placeholder={_('Contraseña')}
                                                iconPassword
                                                {...this.getFieldProps('password')}
                                            />
                                            <div
                                                className={classNames(
                                                    this.validatePassword() && styles.green,
                                                    styles.verifyPassword
                                                )}
                                            >
                                                {this.validatePassword() && (
                                                    <span id={styles.check} className='material-icons'>
                                                        done
                                                    </span>
                                                )}
                                                <Title
                                                    size='md'
                                                    align='left'
                                                    className={classNames(
                                                        styles.description,
                                                        this.validatePassword() && styles.green
                                                    )}
                                                >
                                                    {_('5 Caracteres')}
                                                </Title>
                                            </div>
                                        </div>
                                        <Input
                                            type='password'
                                            size='md'
                                            color={settings.app.theme}
                                            appearance='outline'
                                            placeholder={_('Repetir contraseña')}
                                            {...this.getFieldProps('confirmPassword')}
                                            iconPassword
                                        />
                                    </div>
                                )}
                                <div className={styles.termsContainer}>
                                    <Label text={this.renderTerms()} appearance='row' reverse size='sm'>
                                        <Toggle type='radio' {...this.getFieldProps('terms')} />
                                    </Label>
                                    <Label text={this.renderPrivacyPolicy()} appearance='row' reverse size='sm'>
                                        <Toggle type='radio' {...this.getFieldProps('privacyPolicy')} />
                                    </Label>
                                </div>
                            </div>
                        )}
                    </Fragment>
                }
                {this.props.showWelcome ? (
                    <div className={styles.buttonContainer}>
                        <Button variant='contained' color='primary' onClick={this.handleSubmit} sx={{ mt: 3 }}>
                            {_('Ingresar')}
                        </Button>
                    </div>
                ) : (
                    <Fragment>
                        {this.props.loginView && (
                            <div className={styles.buttonContainer}>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    sx={{ mt: 3 }}
                                    disabled={
                                        !this.props.password
                                            ? !this.validateFields(this.firstFields)
                                            : !this.validateFields(this.secondFields)
                                    }
                                    onClick={this.props.password ? this.changeToWelcomeView : this.props.nextBtn}
                                >
                                    {this.props.password ? _('Terminar') : _('Siguiente')}
                                </Button>
                                {this.props.password && <FormMessage style='error'>{this.state.apiError}</FormMessage>}
                            </div>
                        )}
                    </Fragment>
                )}
                {
                    <Popup
                        visible={this.state.showPopupDeleteAccount}
                        showCloseIcon
                        onClose={this.togglePopupDeleteAccount}
                    >
                        <DeleteAccount
                            closePopup={this.togglePopupDeleteAccount}
                            acceptDelete={this.togglePopupConfirmDeleteAccount}
                        />
                    </Popup>
                }
                {
                    <Popup
                        visible={this.state.showPopupConfirmDeleteAccount}
                        showCloseIcon
                        onClose={this.togglePopupConfirmDeleteAccount}
                    >
                        <ConfirmDeleteAccount
                            closePopup={this.togglePopupConfirmDeleteAccount}
                            user={this.props.user}
                        />
                    </Popup>
                }
                {
                    <Popup visible={this.state.showPopupFinishDeleteAccount}>
                        <FinishDeleteAccount />
                    </Popup>
                }
            </div>
        );
    }
}
